import * as Styled from './styled'
import TtsTextArea from '../../TextArea'

interface IVoiceToneInstructionProps {
  projectInitialToneInstruction?: string
  toneInstruction?: string
  handleToneTextChange: (text: string) => void
}

const TTS_INSTRUCTION_TEXT_AREA_HEIGHT = 112

export const VoiceToneInstruction: React.FC<IVoiceToneInstructionProps> = ({
  projectInitialToneInstruction = '',
  toneInstruction = '',
  handleToneTextChange
}) => {
  return (
    <Styled.ToneInstructionWrapper>
      <TtsTextArea
        isActive
        textValue={toneInstruction}
        mutableTtsTextValue={toneInstruction}
        initialTtsTextValue={projectInitialToneInstruction}
        setTextValue={handleToneTextChange}
        isDefaultStateFocused={false}
        maxHeight={TTS_INSTRUCTION_TEXT_AREA_HEIGHT}
        minHeight={TTS_INSTRUCTION_TEXT_AREA_HEIGHT}
        inputFixHeight={TTS_INSTRUCTION_TEXT_AREA_HEIGHT}
      />
    </Styled.ToneInstructionWrapper>
  )
}
